import { Mapper } from '../../../../base/utils/mapper';
import { ComercialDetailModel } from '../../../../domain/models/comercial/comercial-detail.model';
import { ComercialDetailEntity } from '../entities/comercial-detail.entity';

export class ComercialDetailImplementationRepositoryMapper extends Mapper<ComercialDetailEntity, ComercialDetailModel> {
  mapFrom(param: ComercialDetailEntity): ComercialDetailModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }

  mapTo(param: ComercialDetailModel): ComercialDetailEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
}
